<template>
  <ul class="LoadDataCom">
    <li
      v-for="(v, i) in loadList"
      :key="i"
      :style="{
        background: EchartsLightColor[i],
      }"
    >
      <h4>{{ v.value }}</h4>
      <p>
        {{ v.display }} <span>{{ v.unit }}</span>
      </p>
    </li>
  </ul>
</template>

<script>
export default {
  props: ["loadList"],
  data() {
    return {
      dataList: [],
      EchartsLightColor,
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.LoadDataCom {
  width: 100%;
  height: 100%;
  @include setFlexStart;
  li {
    width: 15.6%;
    height: 100%;
    margin-right: 1%;
    border-radius: 10px;
    color: #fff;
    @include setFlexColumn;
    justify-content: center;
    h4 {
      font-size: 16px;
      text-indent: 20px;
      margin-bottom: 5px;
    }
    p {
      text-indent: 20px;
      span {
        font-size: 12px;
      }
    }
  }
}
</style>
